const baseURL = "https://guarantees.boxbyld.tech/api"
export const register = `${baseURL}/register-user`;
export const login = `${baseURL}/login`;
export const create_bank_lead = `${baseURL}/leads-bank/store`;
export const update_bank_lead = `${baseURL}/leads-bank/update-available-lead`;
export const available_leads = `${baseURL}/leads-bank/available-leads`;
export const delete_lead = `${baseURL}/leads-bank/delete-available-lead`;
export const show_lead = `${baseURL}/leads-bank/show-available-lead`;
export const service_type = `${baseURL}/leads-bank/service-type`;
export const countries = `${baseURL}/countries`;
export const cities = `${baseURL}/countries/cities`;
export const state = `${baseURL}/countries/country`;
export const show_sold_lead = `${baseURL}/leads-bank/sold-leads`;



